import { driverMachine } from '~/entities/common/Driver'
import {
  Car,
  CarLicensee,
  Region,
  Subdivision,
  WorkRule,
  YandexWorkRule,
} from '~/shared/api'
import { Filter } from '~/shared/ui/AsyncGrid'

export const filters: Filter[] = [
  {
    field: 'fullName',
    label: 'filter.full name',
    type: 'text',
  },
  {
    field: 'drivingLicenseNumber',
    label: 'filter.driving license number',
    type: 'text',
  },
  {
    field: 'phone',
    label: 'filter.phone',
    type: 'text',
  },
  {
    field: 'status',
    label: 'filter.status',
    type: 'select',
    options: Object.entries(driverMachine.states)
      .filter(([, node]) => node.config.meta.gridFilter)
      .map(([key, node]) => ({
        id: key,
        label: node.config.meta.label ?? key,
      })),
  },
  {
    field: 'carId',
    label: 'filter.car',
    type: 'autocomplete',
    fetchOptions: Car.fetchOptions,
  },
  {
    field: 'regionId',
    label: 'filter.region',
    type: 'autocompleteMultiple',
    fetchOptions: Region.fetchOptions,
  },
  {
    field: 'subdivisionId',
    label: 'filter.subdivision',
    type: 'autocompleteMultiple',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    field: 'licenseeId',
    label: 'filter.licensee',
    type: 'autocomplete',
    fetchOptions: CarLicensee.fetchOptions,
  },
  {
    field: 'workRuleId',
    label: 'filter.work rule',
    type: 'autocompleteMultiple',
    fetchOptions: WorkRule.fetchOptions,
  },
  {
    field: 'yandexWorkRuleId',
    label: 'filter.yandex work rule',
    type: 'autocompleteMultiple',
    fetchOptions: YandexWorkRule.fetchOptionsWithAccount,
    canAsyncSearch: false,
  },
  {
    field: 'snils',
    label: 'filter.snils',
    type: 'text',
  },
  {
    field: 'priceChangedManually',
    label: 'filter.price is changed manually',
    type: 'boolean',
  },
]
